"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cocconato": {
    "8b81c6a1": [{
      "hkey": "2020216b",
      "slug": "cocconito-vignaretto",
      "name": "Cocconito Vignaretto",
      "primary": true,
      "skipSearch": false
    }],
    "cocconito": [{
      "hkey": "2020216b",
      "slug": "cocconito-vignaretto",
      "name": "Cocconito Vignaretto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5a7ebee2": [{
      "hkey": "812c7b45",
      "slug": "tabiella",
      "name": "Tabiella",
      "primary": true,
      "skipSearch": false
    }],
    "foino-tabiella": [{
      "hkey": "812c7b45",
      "slug": "tabiella",
      "name": "Tabiella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;